import type { FirmSetupAccountsRequest } from '../types';

/** Flat query params accepted by fetchBaseQuery / URLSearchParams. */
export type SetupAccountsQueryParams = Record<
  string,
  string | number | boolean
>;

/**
 * Expands nested Sort / InvestorIds into bracketed keys the firm CustomModelBinder
 * and grid APIs expect (e.g. sort[0].Property, InvestorIds[0]).
 */
export function buildSetupAccountsQueryParams(
  args: FirmSetupAccountsRequest,
): SetupAccountsQueryParams {
  const params: SetupAccountsQueryParams = {};

  if (args.AdvisorInstitutionWealthId !== undefined) {
    params.AdvisorInstitutionWealthId = args.AdvisorInstitutionWealthId;
  }
  if (args.ExternalId !== undefined) {
    params.ExternalId = args.ExternalId;
  }
  if (args.ExternalGuid !== undefined) {
    params.ExternalGuid = args.ExternalGuid;
  }
  if (args.AdvisorId !== undefined) {
    params.AdvisorId = args.AdvisorId;
  }
  if (args.InvestorId !== undefined) {
    params.InvestorId = args.InvestorId;
  }
  if (args.OnlyUnassigned !== undefined) {
    params.OnlyUnassigned = args.OnlyUnassigned;
  }
  if (args.WealthId !== undefined) {
    params.WealthId = args.WealthId;
  }
  if (args.Limit !== undefined) {
    params.Limit = args.Limit;
  }
  if (args.Page !== undefined) {
    params.Page = args.Page;
  }
  if (args.SearchTerm !== undefined) {
    params.SearchTerm = args.SearchTerm;
  }

  args.Sort?.forEach((sortItem, index) => {
    params[`sort[${String(index)}].Property`] = sortItem.Property;
    params[`sort[${String(index)}].Direction`] = sortItem.Direction;
    params[`sort[${String(index)}].Order`] = sortItem.Order;
  });

  args.InvestorIds?.forEach((investorId, index) => {
    params[`InvestorIds[${String(index)}]`] = investorId;
  });

  return params;
}
